import React, { FC, useEffect } from 'react';

import './CookieModal.scss';

import TemplateModal from 'components/common/modals/TemplateModal';
import Button from 'components/common/ui-kit/Button';
import Link from 'components/common/ui-kit/Link';
import useAppDispatch from 'hooks/common/useAppDispatch';
import terms from 'i18n';
import { hideModal } from 'redux/actions';

const CookieModal: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const hasAcceptedCookies = localStorage.getItem('cookie-accepted');
    if (hasAcceptedCookies) {
      dispatch(hideModal());
    }
  }, [dispatch]);

  const handleAcceptAll = () => {
    localStorage.setItem('cookie-accepted', 'true');
    dispatch(hideModal());
  };

  return (
    <TemplateModal
      title={terms.COOKIE_TITLE}
      className="cookie-modal"
      showCloseButton={false}
    >
      <div className="cookie-modal__content">
        <p className="cookie-modal__description">
          {terms.USE_COOKIES}{' '}
          <Link href="/documents/personal_cookie.pdf" target="_blank">
            {terms.FILE_COOKIES}
          </Link>
        </p>

        <div className="cookie-modal__actions">
          <Button theme="success" onClick={handleAcceptAll}>
            {terms.ACCEPT}
          </Button>
        </div>
      </div>
    </TemplateModal>
  );
};

export default CookieModal;
